import React, { useState } from "react";
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
} from "react-share";
import { Menu, MenuItem, Tooltip } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import { toast } from "react-toastify";

const ShareButtonPhone = ({ url }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const realtorCode = localStorage.getItem("realtor_code");
    const shareUrl = realtorCode ? url : window.location.href; // Use provided URL or fallback to current page
    const message = encodeURIComponent("Hey, check this out! This might interest you: " + shareUrl);

    // Open/Close Menu
    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    // Copy to Clipboard
    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied to clipboard!");
        handleClose();
    };

    return (
        <div>
            <Tooltip title="Share">
                {/* <IconButton onClick={handleOpen} style={{ marginRight: 8, color: "#dd483b" }}>
                    <ShareIcon />
                </IconButton> */}
                <div className="share-btn" onClick={handleOpen} style={{ cursor: "pointer" }}>
                    <svg
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect width="24" height="24" rx="4" fill="#E55426" />
                        <path
                            d="M15.307 14.7623C14.5404 14.7623 13.8497 15.0934 13.3704 15.62L9.05871 12.9496C9.17708 12.647 9.23777 12.3249 9.23765 12C9.23779 11.6751 9.1771 11.353 9.05871 11.0504L13.3704 8.37987C13.8497 8.90649 14.5404 9.23768 15.307 9.23768C16.7511 9.23768 17.9259 8.06287 17.9259 6.61878C17.9259 5.17469 16.7511 4 15.307 4C13.8629 4 12.6881 5.17481 12.6881 6.6189C12.688 6.94381 12.7487 7.26586 12.867 7.56846L8.55552 10.2389C8.07615 9.71227 7.38549 9.38108 6.6189 9.38108C5.17481 9.38108 4 10.556 4 12C4 13.444 5.17481 14.6189 6.6189 14.6189C7.38546 14.6189 8.07618 14.2878 8.55552 13.7611L12.8671 16.4315C12.7487 16.7341 12.688 17.0562 12.6881 17.3812C12.6881 18.8252 13.8629 20 15.307 20C16.7511 20 17.9259 18.8252 17.9259 17.3812C17.9259 15.9371 16.7511 14.7623 15.307 14.7623ZM13.643 6.6189C13.643 5.7014 14.3895 4.95497 15.307 4.95497C16.2244 4.95497 16.9709 5.7014 16.9709 6.6189C16.9709 7.5364 16.2245 8.28284 15.307 8.28284C14.3895 8.28284 13.643 7.53637 13.643 6.6189ZM6.6189 13.6639C5.70128 13.6639 4.95484 12.9175 4.95484 12C4.95484 11.0825 5.70128 10.3361 6.6189 10.3361C7.5364 10.3361 8.28271 11.0825 8.28271 12C8.28271 12.9175 7.53637 13.6639 6.6189 13.6639ZM13.643 17.3811C13.643 16.4636 14.3895 15.7171 15.307 15.7171C16.2244 15.7171 16.9709 16.4636 16.9709 17.3811C16.9709 18.2986 16.2245 19.045 15.307 19.045C14.3895 19.045 13.643 18.2986 13.643 17.3811V17.3811Z"
                            fill="white"
                        />
                    </svg>
                </div>

            </Tooltip>


            {/* Share Menu */}
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem onClick={handleClose}>
                    <a href={`mailto:?subject=Check this out&body=${message}`} style={{ display: "flex", alignItems: "center", width: "100%", textDecoration: "none", color: "inherit" }}>
                        <EmailIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Email
                    </a>
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <a href={`sms:?body=${shareUrl}`} style={{ display: "flex", alignItems: "center", width: "100%", textDecoration: "none", color: "inherit" }}>
                        <SmsIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Text Message
                    </a>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <FacebookShareButton url={shareUrl} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <FacebookIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Facebook
                    </FacebookShareButton>
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <TwitterShareButton url={shareUrl} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <TwitterIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Twitter
                    </TwitterShareButton>
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <LinkedinShareButton url={shareUrl} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <LinkedInIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> LinkedIn
                    </LinkedinShareButton>
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <WhatsappShareButton url={shareUrl} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <WhatsAppIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> WhatsApp
                    </WhatsappShareButton>
                </MenuItem>

                <MenuItem onClick={copyToClipboard}>
                    <ContentCopyIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Copy Link
                </MenuItem>
            </Menu>
        </div>
    );
};

export default ShareButtonPhone;
